import type { Reducer } from 'react';
import { useReducer } from 'react';

type ImageGalleryState =
  | {
      isOpen: true;
      initialImageIndex: number;
    }
  | {
      isOpen: false;
      initialImageIndex: null;
    };

const imageGalleryStateReducer: Reducer<ImageGalleryState, number | null> = (
  _state: ImageGalleryState,
  imageIndex = null,
) => {
  if (imageIndex !== null) {
    return {
      initialImageIndex: imageIndex,
      isOpen: true,
    };
  }
  return {
    isOpen: false,
    initialImageIndex: null,
  };
};

export function useImageGalleryState() {
  const [state, dispatch] = useReducer(imageGalleryStateReducer, {
    isOpen: false,
    initialImageIndex: null,
  });

  return {
    state,
    open: (index: number) => dispatch(index),
    close: () => dispatch(null),
  };
}
